<template>
    <section class="categories" style="display: flex;">
        <select v-model="selectedCat" class="form-control">
            <optgroup v-for="item in categories" :label="item.title">
                 <option :value="sitem.id" v-for="sitem in item.children">{{sitem.title}}</option>
            </optgroup>
        </select>&nbsp;
        <button class="btn btn-primary btn-sm" @click.prevnet="updateCat">移動</button>
    </section>
    
</template>


<script>
    export default {
        props: ['apiUrl', 'categories'],

        data() {
            return {
                store: window.store,
                selectedCat: null
            }
        },

        methods: {
            updateCat(){

                let data = {
                    ids: this.store.ids,
                    cat: this.selectedCat
                };
                axios.post(`${this.apiUrl}/updateCat`, data).then( response => {
                    this.selectedCat = null;
                    location.reload();
                })
            }
        }
    }
</script>